module.exports = __webpack_public_path__ + "static/media/aeromeghLogo.f911a352.png";